import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/frontend/src/components/common/PageLoader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PageShell"] */ "/vercel/path0/frontend/src/components/layout/PageShell.tsx");
